<template>
  <Popup show="{{isPopupShow}}" closeable="{{false}}">
    <view class="success-popup-container">
      <image
        class="light-pic"
        src="https://ut-static.udache.com/webx/sfc/SRVycloESs8uAt7WibScn_guang.apng"
        mode="widthFix"
      />
      <image
        class="success-pic"
        src="https://ut-static.udache.com/webx/sfc/7R_1rEVMK7Vm_wgaQRKPQ.png"
      />
      <view class="coupon-list-wrapper">
        <view class="coupon-list">
          <view class="coupon-list-title">
            <view class="coupon-list-title-item">恭喜你</view>
            <view class="coupon-list-title-item">获得价值{{ totalAmount }}元券包</view>
          </view>
          <view class="reward-coupon-item" wx:for="{{rewardCouponList}}">
            <view class="reward-coupon-item-left">
              <view class="price">
                <view class="num">{{ getAmount(item) }}</view>
                <view class="unit">元</view>
              </view>
            </view>
            <view class="reward-coupon-item-right">
              <view wx:if="{{item.name}}" class="name">{{ item.name }}</view>
              <view wx:if="{{item.remark}}" class="remark">{{ item.remark }}</view>
            </view>
          </view>
        </view>
      </view>
      <image
        class="btn-pic"
        src="https://ut-static.udache.com/webx/sfc/mbMgwUYV-8Kyax9b6G-5f.png"
        mode="widthFix"
        bindtap="receive"
      />
      <image
        bindtap="close"
        class="close-icon"
        src="https://ut-static.udache.com/webx/sfc/zDAAD6_KoVVbL7DpWKbcG.png"
      />
    </view>
  </Popup>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { getFinalPrice } from '@/utils/money'
  import { trackEvent } from '@/common/track'
  import { debounce } from '@/utils'

  createComponent({
    props: {
      isPopupShow: {
        type: Boolean,
        value: false
      },
      totalAmount: {
        type: Number,
        value: 0
      },
      rewardCouponList: {
        type: Array,
        value: () => []
      }
    },
    watch: {
      isPopupShow: {
        immediate: true,
        handler(val) {
          if (val) {
            trackEvent(
              'userteam_train_guestspeedup_coupons_sw',
              'UT-客态加速h5页-优惠券弹窗-曝光',
              {}
            )
          }
        }
      }
    },
    computed: {},
    methods: {
      close() {
        trackEvent('userteam_train_guestspeedup_coupons_ck', 'UT-客态加速h5页-优惠券弹窗-点击', {
          module: 'close'
        })
        this.triggerEvent('close')
      },
      receive: debounce(function() {
          trackEvent('userteam_train_guestspeedup_coupons_ck', 'UT-客态加速h5页-优惠券弹窗-点击', {
            module: 'take'
          })
          this.triggerEvent('receive')
        },300,false
      ), 
      getAmount(item) {
        return getFinalPrice(item.amount ?? 0)
      }
    }
  })
</script>

<style scoped lang="stylus">
  .success-popup-container
    width 270px
    border-radius 37.5px
    position relative
    .coupon-list-wrapper
      width 100%
      position relative
      padding 7px 8.5px 8px 8.5px
      border-radius 37.5px
      box-sizing border-box
      z-index 2
      background #FF6B35
      .coupon-list
        position relative
        z-index 2
        height 100%
        padding 16px 17px 78px 17px
        display flex
        flex-direction column
        align-items center
        border-radius 30.5px
        box-sizing border-box
        border 3.5px solid #FFFFFF
        -webkit-mask radial-gradient(circle at 7.5px 80px, transparent 7.5px, #000 0) -7.5px
        mask radial-gradient(circle at 7.5px 80px, transparent 7.5px, #000 0) -7.5px
        background linear-gradient(243deg, rgba(255, 254, 252, 0.9) 0%, rgba(255, 252, 242, 0.9) 60%, rgba(255, 251, 238, 0.9) 98%), linear-gradient(340deg, rgba(255, 242, 209, 0) 71%, rgba(122, 232, 255, 0.353) 106%), linear-gradient(49deg, rgba(255, 255, 255, 0) 54%, #F5FFDA 110%), #FFFFFF
        &-title
          display flex
          flex-direction column
          align-items center
          font-family PingFangSC-Semibold
          font-size 21px
          font-weight 600
          letter-spacing 0px
          color #FF6427
          margin-bottom 8px
          &-item
            line-height 25px
            &:not(:last-child)
              margin-bottom 1.5px
        .reward-coupon-item
          width 100%
          position relative
          height 56px
          display flex
          align-items center
          background linear-gradient(264deg, #FFF5B5 -63%, #FFF9E7 67%, #FFFAEA 99%)
          border 1px solid #FFE0AD
          box-sizing border-box
          border-radius 10px
          &:not(:last-child)
            margin-bottom 8px
          .reward-coupon-item-left
            width 71.5px
            height 100%
            display flex
            justify-content center
            align-items center
            .price
              display flex
              justify-content center
              align-items baseline
              .num
                font-family Barlow Semi Condensed
                font-size 30px
                font-weight 400
                line-height 30px
                letter-spacing 0px
                color #FF6427
              .unit
                font-family PingFangSC-Regular
                font-weight 400
                font-size 14px
                line-height 14px
                text-align center
                letter-spacing 0px
                color #FF6427
          .reward-coupon-item-right
            flex 1
            padding-left 20px
            display flex
            flex-direction column
            justify-content center
            .name
              font-family PingFangSC-Semibold
              font-size 14px
              font-weight 600
              line-height 14px
              letter-spacing 0px
              color #543018
              margin-bottom 4px
            .remark
              font-family PingFangSC-Regular
              font-weight 400
              font-size 10px
              line-height 10px
              letter-spacing 0px
              color #B98664
    .light-pic
      width 130vw
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      z-index 1
    .success-pic
      position absolute
      top -96.5px
      left 50%
      transform translateX(-50%)
      height 124px
      width 310px
      z-index 2
    .btn-pic
      width 100%
      position absolute
      bottom -49px
      left 0
      z-index 2
    .close-icon
      height 36px
      width 36px
      position absolute
      bottom -114.5px
      left 50%
      transform translateX(-50%)
      z-index 2
</style>

<script name="json">
    module.exports = {
      component: true,
      usingComponents: {
        Popup: '@didi/spring-ui/ts-popup'
      }
    }
</script>